import $ from 'jquery';

try {
    const $h = $('#mainheader');
    const $bg = $h.find('.header__bg');
    const _h = $h.height();

    $(window).on('scroll', () => {
        const scr = window.scrollY;
        let h = _h;
        h -= scr / 10;
        if (h < 100) h = 100;
        $h.css('height', h + 'px');
        $bg.css('opacity', (((_h - h) / 23) * 0.3) + 0.7);
    });
    $(window).trigger('scroll');

    $('.header__hamburger').on('click', () => {
        $('.header__hamburger, .header__hamburger > .plate').toggleClass('active');
    });
} catch (e) {
    console.error(e);
}